module.exports = __webpack_public_path__ + "images/historical/Added_to_list.png";